/**
 * API origin configuration.
 *
 * Production backend: https://api.poseidon.withmeridian.ai (owner, 2026-07-31).
 * Empty string means same-origin relative paths (the backend docs' preferred
 * deployment). Cross-origin requires the backend's APP_ORIGIN to be
 * https://poseidon.withmeridian.ai and credentials to ride CORS.
 */
/** Demo fixtures are dev-only; '0' hard-disables them for production builds. */
export const DEMO: boolean = import.meta.env.VITE_DEMO !== '0';

/**
 * Build-time constant only (handoff 15.1): never from user input or runtime
 * content. VITE_API_ORIGIN exists for local mock/dev wiring; a live build
 * without it uses the exact pinned production origin.
 */
export const API_ORIGIN: string =
  import.meta.env.VITE_API_ORIGIN ?? (DEMO ? '' : 'https://api.poseidon.withmeridian.ai');

/** IAP sign-in is a top-level navigation to this URL, never a fetch (handoff 15.3). */
export const LOGIN_URL = `${API_ORIGIN}/auth/login`;

export function apiUrl(path: string): string {
  return `${API_ORIGIN}${path}`;
}

/** Live walk progress SSE for one bucket (EventSource, withCredentials). */
export function walkEventsUrl(bucketId: string): string {
  return `${API_ORIGIN}/api/v1/buckets/${encodeURIComponent(bucketId)}/walk/events`;
}
